//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ordini_mixin from "../mixin/ordini_mixin";
import OrdineElement from "./ordine_element_mobile";
export default {
  components: {
    OrdineElement,
  },
  mixins: [ordini_mixin],
};
